const ReauthenticateIcon = (props) => {
    const theme = localStorage.getItem('theme') || 'light'
    const color = theme === 'light' ? 'rgba(53, 100, 217, 1)' : '#FFFFFF'

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.44618 7.33979C7.39283 6.21161 8.66062 5.39848 10.0808 5.00863C11.501 4.61878 13.0063 4.67068 14.3962 5.15744C15.7862 5.6442 16.995 6.54273 17.8617 7.73344C18.7283 8.92415 19.2119 10.3506 19.2478 11.8229C19.2838 13.2952 18.8706 14.7435 18.0631 15.9751C17.2556 17.2068 16.0922 18.1633 14.7276 18.7173C13.3631 19.2714 11.8622 19.3968 10.4246 19.0768C8.98709 18.7568 7.68109 18.0065 6.68046 16.9259"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.75 12L4.25 12M13.75 12L10.75 15M13.75 12L10.75 9"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ReauthenticateIcon
